import { call, put, select } from 'redux-saga/effects';

import actions from '../../../actions';
import api from '../../../api';
import ModalTypes from '../../../constants/ModalTypes';
import selectors from '../../../selectors';
import request from '../request';

const isTgDebugEnabled = () => {
  try {
    if (typeof window === 'undefined') {
      return false;
    }

    const byStorage = window.localStorage?.getItem('debugTG') === '1';
    const byQuery = new URLSearchParams(window.location.search).get('debugTG') === '1';

    return byStorage || byQuery;
  } catch {
    return false;
  }
};

export function* openModal(type, data) {
  yield put(actions.openModal(type, data));

  if (type === ModalTypes.USER_SETTINGS) {
    const debugEnabled = isTgDebugEnabled();

    if (debugEnabled) {
      const currentUser = yield select(selectors.selectCurrentUser);
      // eslint-disable-next-line no-console
      console.log('[TG][UserSettings] open modal, currentUser(before)=', {
        id: currentUser?.id,
        telegramId: currentUser?.telegramId,
        tgActivateLink: currentUser?.tgActivateLink,
      });
    }

    try {
      const { item: user } = yield call(request, (headers) =>
        api.getCurrentUser(false, headers, debugEnabled),
      );

      if (debugEnabled) {
        // eslint-disable-next-line no-console
        console.log('[TG][UserSettings] fetched /users/me ->', {
          id: user?.id,
          telegramId: user?.telegramId,
          tgActivateLink: user?.tgActivateLink,
        });
      }

      yield put(actions.handleUserUpdate(user, undefined, true));
    } catch (error) {
      if (debugEnabled) {
        // eslint-disable-next-line no-console
        console.warn('[TG][UserSettings] failed to fetch /users/me', error);
      }
    }
  }
}

export function* closeModal() {
  yield put(actions.closeModal());
}

export default {
  openModal,
  closeModal,
};
